import { useEffect } from "react";
import { Link } from "react-router-dom";
import AnimatedBackground from "../../common/AnimatedBackground";
import SEOHead from "../../common/SEOHead";
import Footer from "../Footer/Footer";

export default function EditorialPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative w-full min-h-lvh text-white flex flex-col">
      <SEOHead
        title="Política Editorial"
        description="Criterios de calidad, transparencia y actualización del contenido técnico publicado en martinofranco.com."
        url="/editorial-policy"
      />
      <AnimatedBackground />

      <main className="relative flex-1 max-w-4xl mx-auto w-full px-6 sm:px-12 py-10">
        <h1 className="text-3xl sm:text-4xl font-bold font-header text-white mb-3">
          Política Editorial
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Última actualización: 9 de abril de 2026.
        </p>

        <div className="h-px bg-gray-700/60 mb-8" />

        <div className="prose-blog text-gray-300 leading-relaxed">
          <p>
            Esta página explica cómo se crea, selecciona y mantiene el contenido
            de martinofranco.com. El objetivo es ofrecer material técnico original,
            útil y verificable para desarrolladores, estudiantes y profesionales
            del sector tecnológico. Esta política editorial refleja nuestro
            compromiso con la calidad, la transparencia y el rigor técnico.
          </p>

          <h2>1. Autoría y experiencia</h2>
          <p>
            Todo el contenido publicado en este sitio es redactado por Franco
            Martino, desarrollador de software con formación en electrónica y
            experiencia práctica en desarrollo web, automatización, proyectos
            open-source y aplicaciones técnicas en contextos reales. El autor
            cursa actualmente la carrera de Ingeniería en Informática en UADE y
            posee certificaciones en ciberseguridad, redes y desarrollo de
            aplicaciones.
          </p>

          <h2>2. Qué tipo de contenido se publica</h2>
          <ul>
            <li><strong>Artículos técnicos originales:</strong> contenido basado en proyectos reales que incluye contexto, decisiones de diseño, implementación y resultados obtenidos.</li>
            <li><strong>Casos de estudio:</strong> análisis detallados de problemas específicos resueltos con tecnología, documentando el proceso completo desde el relevamiento hasta la solución.</li>
            <li><strong>Recursos educativos:</strong> guías, tutoriales y material didáctico orientado a buenas prácticas de ingeniería de software, automatización y electrónica aplicada.</li>
            <li><strong>Documentación de proyectos:</strong> descripción de herramientas, librerías y productos desarrollados, con énfasis en su utilidad práctica y las lecciones aprendidas.</li>
          </ul>
          <p>No se publica contenido promocional, artículos genéricos sin sustento técnico, ni material reescrito de fuentes no atribuidas.</p>

          <h2>3. Criterios de calidad</h2>
          <p>Cada artículo publicado debe cumplir con los siguientes estándares:</p>
          <ul>
            <li>
              <strong>Originalidad:</strong> prioridad absoluta en contenido basado en experiencia propia por encima de textos genéricos, reescritos o traducidos de otras fuentes.
            </li>
            <li>
              <strong>Claridad técnica:</strong> estructura legible, explicaciones progresivas y foco en resolver problemas concretos. El código y los ejemplos incluidos deben ser funcionales y estar probados.
            </li>
            <li>
              <strong>Contexto completo:</strong> inclusión de limitaciones, decisiones de diseño y alternativas consideradas, para aportar valor práctico más allá de la receta paso a paso.
            </li>
            <li>
              <strong>Verificabilidad:</strong> cuando sea posible, se incluyen enlaces a repositorios, herramientas o referencias que permitan al lector verificar o reproducir lo descrito.
            </li>
          </ul>

          <h2>4. Proceso de actualización</h2>
          <p>
            Los artículos publicados se revisan periódicamente para corregir errores,
            actualizar enlaces rotos, mejorar ejemplos y reflejar cambios en las
            tecnologías o prácticas recomendadas. La fecha de la última actualización
            de cada artículo se indica en la página correspondiente. Los lectores
            pueden sugerir actualizaciones o correcciones a través de la sección de
            contacto.
          </p>

          <h2>5. Transparencia y conflictos de interés</h2>
          <p>
            Cuando un contenido incluya colaboraciones, enlaces de afiliados,
            menciones patrocinadas o cualquier relación que pudiera generar un
            conflicto de interés, se informará de forma explícita y visible al
            inicio del artículo. La prioridad editorial es mantener la independencia
            técnica y la utilidad para el lector por encima de cualquier interés
            comercial.
          </p>
          <p>
            Las herramientas y productos mencionados en los artículos se incluyen
            porque el autor las ha utilizado y considera que aportan valor, no como
            resultado de acuerdos comerciales. Cuando se mencionan proyectos propios
            (como myATS o Cod-ES), se identifica claramente la autoría.
          </p>

          <h2>6. Correcciones y erratas</h2>
          <p>
            Si detectás un error factual, técnico o de redacción en cualquier
            contenido del sitio, podés reportarlo mediante la página de contacto.
            Las correcciones confirmadas se aplican lo antes posible y se deja
            constancia de la corrección cuando la modificación es significativa.
          </p>
          <p>
            El sitio mantiene un compromiso con la mejora continua del contenido
            publicado y agradece las contribuciones de la comunidad que ayudan a
            mantener la precisión técnica del material.
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="text-gray-500 hover:text-white text-sm transition-colors duration-200 underline underline-offset-4"
          >
            ← Volver al portfolio
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}